


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Order } from '@accounting/interfaces/order';

@Component({
  name: 'bpc-header-shopping-cart-area',
  components: {},
})
export default class Header extends Vue {
  public ordersSubscription = null;
  public loading: boolean = false;
  public orders: Order[] = [];

  public mounted() {
    this.getOrders();
    this.$root.$on('refresh-orders', () => {
      this.getOrders();
    });
  }

  public destroyed() {
    this.$root.$off('refresh-orders');
  }

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get orderCount() {
    // PROVISIONAL. WE CAN DELETE IT WHEN WE WANT ORDERS WITH TYPE DIFFERENTS TO ENROLLMENTS (BOOKING, SUBSCRIPTION...)
    const enrollmentOrders = this.orders.filter(order => {
      return (
        order.type == 'enrollment' ||
        order.type === 'booking' ||
        order.type === 'subscription' ||
        order.type === 'attendee'
      );
    });
    return enrollmentOrders.length;
  }

  public getOrders(): void {
    this.loading = true;

    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath(
      'orders',
      'raw',
    )}/shopping-cart`;

    const queryConfig = {
      params: {
        status: this.initialStatusForOrders(),
        contact_id: this.$authService.getContactId(),
      },
    };
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(
      fetchEntityPath,
      queryConfig,
    );

    if (this.ordersSubscription) {
      this.ordersSubscription.unsubscribe();
    }

    this.ordersSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.orders = res.data;
        this.loading = false;
      },
      error => {
        console.log(error);
        this.loading = false;
      },
    );
  }

  private initialStatusForOrders() {
    return ['shopping_cart']; // TODO - BPS - 1971 => This must be gotten by the options
  }
}
